/* eslint-disable no-unused-vars */
import {
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from '@material-ui/core';
import {
  Page as PDFPage,
  View,
  Document,
  StyleSheet,
  PDFViewer,
  pdf
} from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import React, { FC, useEffect } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { RenderCompanyInfo } from './RenderCompanyInfo';
import { RenderCustomerInfo } from './RenderCustomerInfo';
import { RenderEmployeeInfo } from './RenderEmployeeInfo';
import { RenderFooter } from './RenderFooter';
import { RenderItemsTable } from './RenderItems';
import { RenderPageNoAndTotal } from './RenderPageNoAndTotal';
import { RenderPages } from './RenderPages';
import { RenderWarrantySlipTitle } from './RenderWarrantySlipTitle';
import {
  GetTransactionsViaTransactionNoResponse,
  LooseLeafBusinessInfo,
  TransactionPrintPageData
} from 'src/types';

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: 'pink'
  },
  container: {
    margin: 15,
    flex: 1
  },
  text: {
    fontSize: 8,
    maxLines: 1
  },
  flex: {
    flex: 1
  }
});

interface Props {
  open: boolean;
  documentTitle: string;
  isBlankPage: boolean;
  isTwoThreeOSeven?: boolean;
  isVATExempted?: boolean;
  transactionStateData: GetTransactionsViaTransactionNoResponse | null;
  pagesData: TransactionPrintPageData[];
  dateSold: string;
  totalAmount: number;
  releasedBy: string;
  toggleOpen: () => void;
  storeBranch?: string;
  overrideOnURL?: string;
  looseLeafBusinessInfo?: LooseLeafBusinessInfo;
}

export const PrintTransactionModalLooseLeaf: FC<Props> = ({
  open,
  toggleOpen,
  documentTitle,
  transactionStateData,
  pagesData,
  dateSold,
  totalAmount,
  releasedBy,
  storeBranch = '',
  overrideOnURL = '',
  isTwoThreeOSeven = false,
  isVATExempted = false,
  looseLeafBusinessInfo
}) => {
  const downloadPdf = async () => {
    const fileName = `${transactionStateData?.transaction_no}`;
    const blob = await pdf(<RenderDocumentForAutoDownload />).toBlob();
    saveAs(blob, fileName);
  };

  useEffect(() => {
    if (overrideOnURL) {
      downloadPdf();
    }
  }, [overrideOnURL, open]);

  const RenderDocumentForAutoDownload = () => {
    return (
      <Document title={documentTitle}>
        <RenderPages
          isVATExempted={isVATExempted}
          overrideOnURL={overrideOnURL}
          storeBranch={storeBranch}
          looseLeafBusinessInfo={looseLeafBusinessInfo}
          isTwoThreeOSeven={isTwoThreeOSeven}
          pagesData={pagesData}
          transactionStateData={transactionStateData}
          dateSold={dateSold}
          totalAmount={totalAmount}
          releasedBy={releasedBy}
        />
      </Document>
    );
  };

  return (
    <Dialog maxWidth={'md'} fullWidth open={open}>
      <DialogTitle>
        <Typography variant="h4">Transaction Details</Typography>
        <IconButton
          aria-label="close"
          style={{
            position: 'absolute',
            right: 5,
            top: 5
          }}
          color="secondary"
          onClick={toggleOpen}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Container maxWidth={false}>
          <PDFViewer
            width="100%"
            height="100%"
            style={{ height: '80vh', width: '100%' }}
          >
            <Document title={documentTitle}>
              <RenderPages
                looseLeafBusinessInfo={looseLeafBusinessInfo}
                isTwoThreeOSeven={isTwoThreeOSeven}
                isVATExempted={isVATExempted}
                overrideOnURL={overrideOnURL}
                storeBranch={storeBranch}
                pagesData={pagesData}
                transactionStateData={transactionStateData}
                dateSold={dateSold}
                totalAmount={totalAmount}
                releasedBy={releasedBy}
              />
            </Document>
          </PDFViewer>
        </Container>
      </DialogContent>
    </Dialog>
  );
};
